<div class="menu-button-row-form">
  <div class="menu-button-row-form__content">
    <div class="menu-button-row-form__action" [class.menu-button-row-form__action--full-width]="isActionOnlyButton">
      <ziro-select [fieldId]="'action'" [attr.data-automation]="'menu-button-action-' + buttonKey()"></ziro-select>
    </div>

    <div class="menu-button-row-form__destination" [hidden]="isActionOnlyButton">
      <ziro-select
        [fieldId]="'entitySearch'"
        [attr.data-automation]="'menu-button-entitySearch-' + buttonKey()"
      ></ziro-select>
      <ziro-text
        [fieldId]="'externalPhoneNumber'"
        [attr.data-automation]="'menu-button-externalPhoneNumber-' + buttonKey()"
      ></ziro-text>
    </div>

    <div class="menu-button-row-form__full-width" [hidden]="!shouldShowAnnouncementType">
      <ziro-radio
        [fieldId]="'announcementType'"
        [attr.data-automation]="'menu-button-announcementType-' + buttonKey()"
      ></ziro-radio>
    </div>

    <div class="menu-button-row-form__full-width" [hidden]="!shouldShowAnnouncementAudio">
      <ziro-file-upload
        [fieldId]="'announcementAudio'"
        [attr.data-automation]="'menu-button-announcementAudio-' + buttonKey()"
      ></ziro-file-upload>
      @if (greetingUploadURL() && acceptedFileTypes.includes(greetingFileExtension())) {
        <audio
          [attr.data-automation]="'greeting-audio'"
          class="mt-2 w-100"
          controls
          [src]="greetingUploadURL()"
          [title]="greetingDownloadName()"
        ></audio>
      }
    </div>

    <div class="menu-button-row-form__full-width" [hidden]="!shouldShowAnnouncementTts">
      <ziro-textarea
        [fieldId]="'announcementTts'"
        [attr.data-automation]="'menu-button-announcementTts-' + buttonKey()"
      ></ziro-textarea>
    </div>
  </div>
</div>
